import MathTool from "../math/MathTool";

export default class FieldTool{
    constructor( width, height, resolutionFactor, noiseScale=0.5){
        this.width = width;
        this.height = height;
        this.resolutionFactor = resolutionFactor;
        this.noiseScale = noiseScale;
        this.buildGrid();
    }

    buildGrid(){
        this.xLeft = parseInt( this.width * -0.5 );
        this.xRight = parseInt( this.width * 1.5 );
        this.yTop = parseInt( this.height * -0.5 );
        this.yBottom = parseInt( this.height * 1.5 );
        this.resolution = this.width * this.resolutionFactor;
        this.numCols = parseInt( (this.xRight - this.xLeft) / this.resolution );
        this.numRows = parseInt( (this.yBottom - this.yTop) / this.resolution );
        console.log( "flowField dimesnions: ", this.numCols, this.numRows );
        this.grid = [];
        this.defaultAngle = Math.PI * 0.25
        for (let c= 0; c<this.numCols; c++) {
            let column = [];
            this.grid.push(column)
            for (let r= 0; r<this.numRows; r++) {
                /* let angle = (r / this.numRows) * Math.PI;
                this.grid[c][r] = angle; */
                //

                let scaled_x = c * this.noiseScale
                let scaled_y = r * this.noiseScale
                // get our noise value, between 0.0 and 1.0
                let noise_val = window.p5App.noise(scaled_x, scaled_y)
                // translate the noise value to an angle (betwen 0 and 2 * PI)
                //let angle = MathTool.map(noise_val, 0, 1, 0, Math.PI * 2)
                //this.grid[c][r] = angle;
                this.grid[c][r] = noise_val;
            }
        }
    }

    getValueAtPosition( x, y ){
        let offsetX = x - this.xLeft;
        let offsetY = y - this.yTop;
        let columnIndex = parseInt( offsetX / this.resolution);
        let rowIndex = parseInt( offsetY / this.resolution);
        if( !this.grid[columnIndex] || !this.grid[columnIndex][rowIndex] ){
            return this.defaultAngle;
        }
        return this.grid[columnIndex][rowIndex];    
    }

    getCurvePoints( startingPoint, num_steps, step_length){
        let points = [];
        let x = startingPoint.x;
        let y = startingPoint.y;
       
        for (let n=0; n<num_steps; n++) {
            points.push( {x,y})
            let offsetX = x - this.xLeft;
            let offsetY = y - this.yTop;
            let columnIndex = parseInt( offsetX / this.resolution);
            let rowIndex = parseInt( offsetY / this.resolution);
            if( !this.grid[columnIndex] || !this.grid[columnIndex][rowIndex] ){
                continue;
            }
            let gridAngle = this.grid[columnIndex][rowIndex];
            let x_step = step_length * Math.cos(gridAngle);
            let y_step = step_length * Math.sin(gridAngle);
            x = x + x_step
            y = y + y_step
        }
        return points;
    }
}